var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-block",style:({color:_vm.textColor,'font-size':_vm.textSize+'px'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }